(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wevow-real-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.wevow-real-stories').forEach((section) => {
      const modal = section.querySelector('[data-wevow-story-modal]');
      const feed = section.querySelector('[data-wevow-story-feed]');
      const openers = section.querySelectorAll('[data-wevow-story-open]');
      const closeButton = section.querySelector('[data-wevow-story-close]');
      const slides = section.querySelectorAll('[data-wevow-story-slide]');
      let frame = null;
      if (!modal || !feed || !openers.length || !slides.length) return;

      const videos = () => Array.from(feed.querySelectorAll('video'));
      const syncUnmuteButtons = () => {
        feed.querySelectorAll('[data-wevow-story-unmute]').forEach((button) => {
          const shell = button.closest('.wevow-real-stories__video-shell');
          const video = shell ? shell.querySelector('video') : null;
          if (!video) return;
          button.hidden = !video.muted && video.volume > 0;
        });
      };
      const activeIndex = () => {
        let closest = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const currentDistance = Math.abs(slide.offsetTop - feed.scrollTop);
          if (currentDistance < distance) {
            distance = currentDistance;
            closest = index;
          }
        });
        return closest;
      };
      const syncPlayback = () => {
        const current = activeIndex();
        slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (index === current) video.play().catch(() => {});
          else {
            video.pause();
            video.muted = true;
          }
        });
        syncUnmuteButtons();
      };
      const closeModal = () => {
        videos().forEach((video) => {
          video.pause();
          video.muted = true;
        });
        syncUnmuteButtons();
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('wevow-story-modal-open');
      };
      openers.forEach((opener) => {
        opener.addEventListener('click', () => {
          const index = Number(opener.dataset.wevowStoryIndex || 0);
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('wevow-story-modal-open');
          window.requestAnimationFrame(() => {
            const slide = slides[index] || slides[0];
            feed.scrollTop = slide.offsetTop;
            feed.focus({ preventScroll: true });
            syncPlayback();
          });
        });
      });
      feed.addEventListener('click', (event) => {
        const button = event.target.closest('[data-wevow-story-unmute]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        const shell = button.closest('.wevow-real-stories__video-shell');
        const video = shell ? shell.querySelector('video') : null;
        if (!video) return;
        videos().forEach((item) => {
          if (item !== video) item.muted = true;
        });
        video.muted = false;
        video.volume = 1;
        video.play().catch(() => {});
        syncUnmuteButtons();
      });
      videos().forEach((video) => {
        video.addEventListener('volumechange', syncUnmuteButtons);
        video.addEventListener('play', syncUnmuteButtons);
      });
      syncUnmuteButtons();
      closeButton.addEventListener('click', closeModal);
      feed.addEventListener('scroll', () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = null;
          syncPlayback();
        });
      }, { passive: true });
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wevow-testimonials"] && !Shopify.designMode) return;
  try {
    
  function setupWevowTestimonials(section) {
    var slider = section.querySelector('.wevow-testimonials__slider');
    var slides = Array.from(section.querySelectorAll('.wevow-testimonials__slide'));
    var dots = Array.from(section.querySelectorAll('.wevow-testimonials__dot'));
    if (!slider || !slides.length || !dots.length || section.dataset.sliderReady === 'true') return;
    section.dataset.sliderReady = 'true';

    var pointerId = null;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;
    var frame = null;

    function getVisibleCount() {
      if (!slides[0]) return 1;
      return Math.max(1, Math.round(slider.clientWidth / slides[0].getBoundingClientRect().width));
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getVisibleCount());
    }

    function getTargetLeft(index) {
      var safeIndex = Math.min(index, getMaxIndex());
      return Math.min(slides[safeIndex].offsetLeft, slider.scrollWidth - slider.clientWidth);
    }

    function updateDots() {
      var maxIndex = getMaxIndex();
      var activeIndex = 0;
      var closestDistance = Infinity;
      dots.forEach(function(dot, index) {
        dot.hidden = index > maxIndex;
        if (index <= maxIndex) {
          var distance = Math.abs(slider.scrollLeft - getTargetLeft(index));
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        }
      });
      dots.forEach(function(dot, index) {
        var active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = Number(dot.dataset.slideIndex || 0);
        slider.scrollTo({ left: getTargetLeft(index), behavior: 'smooth' });
      });
    });

    slider.addEventListener('pointerdown', function(event) {
      if (event.button !== 0 || slider.scrollWidth <= slider.clientWidth) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = slider.scrollLeft;
      moved = false;
      slider.classList.add('is-dragging');
      slider.setPointerCapture(pointerId);
    });

    slider.addEventListener('pointermove', function(event) {
      if (event.pointerId !== pointerId) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) moved = true;
      slider.scrollLeft = startScrollLeft - delta;
      if (moved) event.preventDefault();
    });

    function finishDrag(event) {
      if (event.pointerId !== pointerId) return;
      if (slider.hasPointerCapture(pointerId)) slider.releasePointerCapture(pointerId);
      pointerId = null;
      slider.classList.remove('is-dragging');
      updateDots();
    }

    slider.addEventListener('pointerup', finishDrag);
    slider.addEventListener('pointercancel', finishDrag);
    slider.addEventListener('scroll', function() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateDots);
    }, { passive: true });
    window.addEventListener('resize', updateDots);
    updateDots();
  }

  function initWevowTestimonials() {
    document.querySelectorAll('.wevow-testimonials').forEach(setupWevowTestimonials);
  }

  document.addEventListener('DOMContentLoaded', initWevowTestimonials);
  document.addEventListener('shopify:section:load', initWevowTestimonials);
  initWevowTestimonials();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wevow-video-reviews-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.wevow-video-reviews').forEach((section) => {
      const modal = section.querySelector('[data-review-modal]');
      const closeButton = section.querySelector('[data-review-close]');
      const openers = Array.from(section.querySelectorAll('[data-review-open]'));
      const slides = Array.from(section.querySelectorAll('[data-review-slide]'));
      const prevButton = section.querySelector('[data-review-prev]');
      const nextButton = section.querySelector('[data-review-next]');
      let activeIndex = 0;

      if (!modal || !closeButton || !openers.length || !slides.length || !prevButton || !nextButton) return;

      const stopAll = () => {
        slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) video.pause();
        });
      };

      const syncSlides = () => {
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.hidden = !isActive;
          const video = slide.querySelector('video');
          if (!video) return;
          if (isActive) video.play().catch(() => {});
          else video.pause();
        });
        prevButton.disabled = activeIndex === 0;
        nextButton.disabled = activeIndex === slides.length - 1;
      };

      const openModal = (index) => {
        activeIndex = index;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('wevow-reviews-modal-open');
        syncSlides();
      };

      const closeModal = () => {
        stopAll();
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('wevow-reviews-modal-open');
      };

      openers.forEach((button, index) => {
        button.addEventListener('click', () => openModal(index));
      });

      prevButton.addEventListener('click', () => {
        if (activeIndex === 0) return;
        activeIndex -= 1;
        syncSlides();
      });

      nextButton.addEventListener('click', () => {
        if (activeIndex >= slides.length - 1) return;
        activeIndex += 1;
        syncSlides();
      });

      closeButton.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });

      document.addEventListener('keydown', (event) => {
        if (modal.hidden) return;
        if (event.key === 'Escape') closeModal();
        if (event.key === 'ArrowLeft' && activeIndex > 0) {
          activeIndex -= 1;
          syncSlides();
        }
        if (event.key === 'ArrowRight' && activeIndex < slides.length - 1) {
          activeIndex += 1;
          syncSlides();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
